import React from 'react'

export default function About() {
  return (
    <div className='container mt-5'>
      <h1>About This Project</h1>
      <h3>NYC Construction App</h3>
<p>This app is based of Mongo/Express Project: NYC Contract Job Application.</p>

Technology Used
Node
Javascript
React JS
Axios
Express
Mongo
Semantic UI
CSS
Vercel (Front-End)
Heroku (Back-End)
Current Project:
https://github.com/dcartist/nyc2020

Previous Project (2019) Github:
https://github.com/dcartist/nycConstructionApp

This is pulling the data from:
https://whispering-bayou-30290.herokuapp.com/api/property

<p>This dataset contains all construction job applications submitted through the Borough Offices, through eFiling, or through the HUB, which have a "Latest Action Date" since January 1, 2000. This dataset contains all job applications submitted through the Borough Offices, through eFiling, or through the HUB, which have a "Latest Action Date" since January 1, 2000.</p>



    </div>
  )
}
